import { withInstall } from '@element-plus/utils/with-install'
import Calendar from './src/calendar.vue'

export const ElCalendar = withInstall(Calendar)
export default ElCalendar

export * from './src/calendar'
